<img class="max-w-[40%]" [alt]="alt()" [src]="effectiveUrl()" />
